export default "__VITE_ASSET__cda91005__"